import { useNavigationItems, useRenderedNavigationItems, useIsActiveRouteProtected, isNavigationLink, type RenderItemFunction, type RenderSectionFunction } from "@squide/firefly";
import { Link, Outlet } from "react-router";

import { PlantzLogo } from "./PlantzLogo.tsx";
import { UserMenu } from "./UserMenu.tsx";

const renderItem: RenderItemFunction = (item, key) => {
    if (!isNavigationLink(item)) {
        return null;
    }

    const { label, linkProps, additionalProps } = item;

    return (
        <li key={key}>
            <Link {...linkProps} {...additionalProps} className="text-muted-foreground hover:text-foreground text-sm transition-colors">
                {label}
            </Link>
        </li>
    );
};

const renderSection: RenderSectionFunction = (elements, key) => (
    <ul key={key} className="flex items-center gap-4">
        {elements}
    </ul>
);

export function RootLayout() {
    const navigationItems = useNavigationItems();
    const navigationElements = useRenderedNavigationItems(navigationItems, renderItem, renderSection);
    const isActiveRouteProtected = useIsActiveRouteProtected(true, { throwWhenThereIsNoMatch: false });

    if (!isActiveRouteProtected) {
        return (
            <main className="bg-background text-foreground flex min-h-screen items-center justify-center">
                <Outlet />
            </main>
        );
    }

    return (
        <div className="bg-background text-foreground flex min-h-screen flex-col">
            <a href="#main-content" className="focus:bg-background sr-only focus:not-sr-only focus:absolute focus:z-50 focus:px-4 focus:py-2 focus:text-sm focus:font-medium">
                Skip to main content
            </a>
            <header className="border-border flex items-center gap-6 border-b px-6 py-3">
                <Link to="/" aria-label="Plantz home">
                    <PlantzLogo className="text-foreground h-7 w-auto" />
                </Link>
                <nav aria-label="Main" className="flex-1">
                    {navigationElements}
                </nav>
                <UserMenu />
            </header>
            <main id="main-content" className="flex-1">
                <Outlet />
            </main>
        </div>
    );
}
